import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FAQ = () => {
  const faqs = [
    {
      question: "What is RenewSantulan and what do you offer?",
      answer: "RenewSantulan is a holistic wellness and nutrition advisory focused on restoring balance and vitality. We offer personalized nutrition counselling, lifestyle coaching, and condition-specific programs for diabetes, PCOS, thyroid health, gut issues, and more — all tailored to your unique needs."
    },
    {
      question: "How is your approach different?",
      answer: "We go beyond calories and meal plans. Our approach combines nutrition science with your lifestyle, habits, and emotional well-being to create sustainable, realistic transformations — not short-term fixes."
    },
    {
      question: "What can I expect from my first consultation?",
      answer: "Your first session focuses on understanding your health story, blood markers, and daily habits. Based on this, we create a personalized, practical plan that helps you feel informed, empowered, and balanced."
    },
    {
      question: "What programs do you offer?",
      answer: "We design specialized programs for Diabetes Management, Gut Health, PCOS & Hormonal Balance, and Lifestyle Disease Prevention. Each program is customized to your body, goals, and lifestyle."
    },
    {
      question: "How do I book a consultation?",
      answer: "You can book directly through our website, call +91 99109 61228, or message us on WhatsApp. All consultations are virtual, so you can connect from anywhere."
    },
    {
      question: "What are your consultation fees and policies?",
      answer: "Fees depend on your program type and duration. Pricing is transparent — discussed upfront during your consultation. We request 24-hour notice for cancellations and handle emergencies with understanding."
    }
  ];

  return (
    <section className="section-padding container-custom">
      <div className="space-y-8 sm:space-y-12 max-w-4xl mx-auto">
        <div className="text-center space-y-2 px-4">
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl text-foreground">
            Frequently Asked Questions
          </h2>
        </div>

        <Accordion type="single" collapsible className="space-y-4 px-4 sm:px-0">
          {faqs.map((faq, index) => (
            <AccordionItem 
              key={index} 
              value={`item-${index}`}
              className="card-enhanced border border-border rounded-lg px-4 sm:px-6"
            >
              <AccordionTrigger className="text-left text-sm sm:text-base text-card-foreground hover:text-primary py-4">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-sm sm:text-base text-muted-foreground pb-4">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>

        <div className="card-enhanced bg-secondary/30 backdrop-blur-sm rounded-lg p-6 sm:p-8 space-y-4 border border-border mx-4 sm:mx-0">
          <h3 className="text-lg sm:text-xl font-semibold text-foreground">Disclaimer</h3>
          <p className="text-xs sm:text-sm text-muted-foreground leading-relaxed">
            The information provided on this website and during consultations is for educational purposes only and is not intended as medical advice. Functional nutrition services are not a substitute for professional medical care. Always consult with your healthcare provider before making any changes to your diet, lifestyle, or treatment plan. Results may vary based on individual circumstances, and no specific outcomes are guaranteed.
          </p>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
